export const isAutomatedBrowser = (): boolean =>
	typeof navigator !== 'undefined' &&
	(navigator.webdriver === true || /HeadlessChrome/.test(navigator.userAgent));
